import * as React from 'react';

const SvgBundle = (props) => (
  <svg
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M10.565 16.63c.229.054.25.354.027.428l-1.317.434c-3.309 1.066-5.05.175-6.125-3.134l-1.067-3.291C1.016 7.758 1.9 6.008 5.208 4.942l.267-.089c.403-.133.799.272.69.682l-.09.357-.817 3.491c-.917 3.925.425 6.092 4.35 7.025l.957.223Z'
      fill='currentColor'
    />
    <path
      d='m14.308 2.675-1.391-.325c-2.784-.658-4.442-.117-5.417 1.9-.25.508-.45 1.125-.617 1.833l-.816 3.492c-.817 3.483.258 5.2 3.733 6.025l1.4.333c.483.117.933.192 1.35.225 2.6.25 3.983-.966 4.683-3.975L18.05 8.7c.817-3.483-.25-5.208-3.742-6.025Zm-1.566 8.433a.623.623 0 0 1-.609.467c-.05 0-.1-.008-.158-.017l-2.425-.616a.624.624 0 0 1 .308-1.209l2.425.617a.623.623 0 0 1 .459.758Zm2.441-2.816a.623.623 0 0 1-.608.466c-.05 0-.1-.008-.158-.016l-4.042-1.025a.625.625 0 0 1 .308-1.209l4.042 1.025a.616.616 0 0 1 .458.759Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgBundle;
